// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper__f8e {
  width: auto;
  min-width: calc(var(--ring-unit) * 58);
}

.header__f70 {
  display: inline-flex;
  align-items: center;
  gap: var(--ring-unit);
}

.logoWrapper__c72 {
  height: 24px;
  width: 24px;
}

.logoWrapper__c72 + .title__acb {
  margin-left: calc(var(--ring-unit) / 2);
}
`, "",{"version":3,"sources":["webpack://./src/modules/constituents/constituent-dialog/constituent-dialog.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,uCAAuC;AACzC","sourcesContent":[".wrapper {\n  width: auto;\n  min-width: calc(var(--ring-unit) * 58);\n}\n\n.header {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--ring-unit);\n}\n\n.logoWrapper {\n  height: 24px;\n  width: 24px;\n}\n\n.logoWrapper + .title {\n  margin-left: calc(var(--ring-unit) / 2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper__f8e`,
	"header": `header__f70`,
	"logoWrapper": `logoWrapper__c72`,
	"title": `title__acb`
};
export default ___CSS_LOADER_EXPORT___;
